<template>
<div class="home__performances__skills__content__bloc mt-4"
    :class="{
        'xl:w-full xl:ml-4': totalTrophies <= 3
    }"
    v-if="!loading">
    <div class="title text-center">
        <span>{{ category.name }}</span>
    </div>
    <div class="skills__bloc">
        <Layout1 :trophies="trophies[1]" v-if="trophies[1] && trophies[1].length"
            :isolated="(!trophies[0] || !trophies[0].length) && (!trophies[2] || !trophies[2].length)"/>
        <Layout0 :trophies="trophies[0]" v-if="trophies[0] && trophies[0].length"/>
        <Layout2 :trophies="trophies[2]" v-if="trophies[2] && trophies[2].length"/>
    </div>
</div>
</template>

<script>
import Layout0 from '@/components/Home/KPIS/Layouts/Format-0.vue'
import Layout1 from '@/components/Home/KPIS/Layouts/Format-1.vue'
import Layout2 from '@/components/Home/KPIS/Layouts/Format-2.vue'

export default {
    components: {
        Layout0,
        Layout1,
        Layout2
    },
    props: {
        category: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            loading: true,
            trophies: [],
            totalTrophies: 0
        }
    },
    mounted() {
        this.fetchTrophies();
    },
    methods: {
        fetchTrophies() {
            this.category.trophies.forEach(trophy => {
                const trophyFormat = trophy.format
                this.trophies[trophyFormat] = this.trophies[trophyFormat] || [];
                this.trophies[trophyFormat].push(trophy);
                this.totalTrophies++;
            });

            this.loading = false;
        }
    }
}
</script>